import React, { Fragment } from 'react';

import { Popover, Transition } from '@headlessui/react';
import { useRouter } from 'next/router';
import { IconType } from 'react-icons';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';

import Button from '@/tayara-kit/Button';

export interface IAction {
  label: string;
  icon: IconType;
  action: () => void;
  classes?: string;
  message?: string;
  shortLabel?: string;
  requiresConfirmation?: boolean;
  hidden?: boolean;
}
interface ItemActionsProps {
  actions: IAction[];
}
const ItemActions: React.FC<ItemActionsProps> = ({ actions }) => {
  const { push } = useRouter();
  const visibleActions = actions.filter((item) => !item.hidden);

  return (
    <div className="flex flex-wrap items-center h-full gap-2">
      {visibleActions.map((item, i) =>
        item.requiresConfirmation ? (
          <Popover key={item.label} className="relative w-fit">
            {({ close }) => (
              <>
                <Popover.Button
                  as={Button}
                  aria-label={item.label}
                  className={`${item.classes} text-blue-500`}
                  icon={<item.icon size={22} />}
                  hidden
                >
                  <span className="hidden md:hidden xl:block text-xs">
                    {item.label}
                  </span>
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel
                    as="div"
                    className="absolute -left-20 w-[15rem] rounded-2xl bg-white p-2 shadow-2xl z-50"
                  >
                    <div className="flex flex-col">
                      <p className="mb-2 p-2 text-xs text-gray-700">
                        {item.message || 'Continuer'}
                      </p>
                      {/* Actions */}
                      <div className="flex flex-1 gap-2">
                        <Button
                          className="shrink font-normal"
                          onClick={() => close()}
                        >
                          <HiOutlineArrowNarrowLeft />
                        </Button>
                        <Button
                          className="basis-full shrink bg-transparent  text-gray-700 font-normal"
                          icon={<item.icon size={17} />}
                          onClick={() => {
                            item.action();
                            close();
                            push('/profile/?t=myListings');
                          }}
                        >
                          Confirmer
                        </Button>
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>
        ) : (
          // eslint-disable-next-line react/jsx-key
          <Button
            key={i}
            onClick={item.action}
            aria-label={item.label}
            className={`${item.classes}
               btn normal-case font-bold rounded-lg bg-transparent hover:bg-slate-100 text-blue-500  border-none !w-fit !px-2`}
            icon={<item.icon size={18} className="text-blue-500" />}
          >
            <span className="hidden md:hidden xl:block text-xs">
              {item.label}
            </span>
          </Button>
        )
      )}
    </div>
  );
};

export default ItemActions;
